import { SessionJsonStorage } from 'utils/storage';
import deliverthatFavicon from 'assets/icons/deliver-that-logo-small.png';
import nccFavicon from 'assets/icons/ncc-logo-small.png';
import {
  ChristmasOCLogoIcon, ChristmasOCSmallLogoIcon, OCLogoIcon, OCSmallLogoIcon,
  DeliveryThatSmallLogo,
  DeliverthatLogo,
  NCCLogo,
  NCCLogoSmall,
} from 'assets/icons';

export const isDevelopment = process.env.NODE_ENV === 'development';
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const apiUrlDeprecated = `${getBaseURL().url}api/v1`;
export const API_URL = `${getBaseURL().url}api/`;
export const IS_CHRISTMAS_TIME = new Date().getMonth() === 11;

export const VAPID_KEY =
  'BJbZo2XzOzzGZDHD-09IedeIeH2dcO3szvQ7VcefCcFaSSfnTyst377TlOqp0W3EOQdV_GgsbcP4CHfI-vr3AXA';

export const RIDE_STATUS = [
  {
    id: 0,
    name: 'processing',
    title: 'Processing',
  },
  {
    id: 1,
    name: 'noDriversAvailable',
    title: 'No Drivers Available',
  },
  {
    id: 6,
    name: 'serviceDisruption',
    title: 'Service Disruption',
  },
  {
    id: 2,
    name: 'accepted',
    title: 'Accepted',
  },
  {
    id: 3,
    name: 'arriving',
    title: 'Arriving',
  },
  {
    id: 4,
    name: 'inProgress',
    title: 'In Progress',
  },
  {
    id: 5,
    name: 'cancelled',
    title: 'Cancelled',
  },
  {
    id: 7,
    name: 'completed',
    title: 'Completed',
  },
];

export const MERCHANT_PANEL_URL = 'https://merchant.omnicart.tech/console/';
export const MERCHANT_TYPE = {
  Partner: 'partner',
  Catering: 'catering',
  Omni: 'omni',
  NonPartner: 'non-partner',
};

export const DAYS = {
  MON: 'Monday',
  TUE: 'Tuesday',
  WED: 'Wednesday',
  THU: 'Thursday',
  FRI: 'Friday',
  SAT: 'Saturday',
  SUN: 'Sunday',
};

export const WEEKDAYS = Object.values(DAYS);

export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]);
export function getBaseURL() {
  let url = !['stage', 'dev'].includes(process.env.REACT_APP_ENV) ? process.env.REACT_APP_BASE_URL :
    SessionJsonStorage.get('baseURL') || process.env.REACT_APP_BASE_URL;

  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    url = `https://${url}`;
  }

  if (!url.endsWith('/')) {
    url = `${url}/`;
  }
  return {
    url,
    customized: process.env.REACT_APP_BASE_URL !== url,
  };
}

export const SUBSCRIPTION_STRIPE_KEY = process.env.REACT_APP_SUBSCRIPTION_STRIPE_KEY;
export const PaymentTypes = {
  CARD: 0,
  CASH: 1,
  ALTERNATE_PAYMENT: 2,
  DEBIT: 3,
  CUSTOM: 4,
  IN_STORE: 5,
  CHEQUE: 6,

  QUOTED: 'quoted',
};

export const OrderType = {
  Pickup: 1,
  Delivery: 2,
};

export const fallbackItemImage = 'data:image/png;base64,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';

const WL_CONFIGS = {
  omnicart: {
    name: 'Omnicart',
    supportPanelUrl: 'https://omnicart-help.freshdesk.com/support/login',
    supportEmail: 'contact@omnicart.tech',
    logo: {
      small: IS_CHRISTMAS_TIME ? ChristmasOCSmallLogoIcon : OCSmallLogoIcon,
      medium: IS_CHRISTMAS_TIME ? ChristmasOCLogoIcon : OCLogoIcon,
    },
    favicon: './icon.png',
    intercom_app_id: 'ienxrwt3',
    colors: {
      primary: '#02862F',
      error: '#E42326',
    },
  },
  ncc: {
    name: 'NCC',
    // supportPanelUrl: 'https://catermind-help.freshdesk.com/support/login',
    supportEmail: 'contact@ncc.com',
    logo: {
      small: NCCLogoSmall,
      medium: NCCLogo,
    },
    favicon: nccFavicon,
    colors: {
      primary: '#05ace4',
      error: '#E42326',
    },
  },
  deliverthat: {
    name: 'Deliverthat',
    // supportPanelUrl: 'https://deliverthat-help.freshdesk.com/support/login',
    supportEmail: 'contact@deliverthat.com',
    logo: {
      small: DeliveryThatSmallLogo,
      medium: DeliverthatLogo,
    },
    favicon: deliverthatFavicon,
    colors: {
      primary: '#05ace4',
      error: '#E42326',
    },
  },
};

export const WL_CONFIG = WL_CONFIGS[process.env.REACT_APP_WL_NAME || 'omnicart'];
